import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import EcosystemGraphic from "./EcosystemGraphic";

const LINES = [
  "Engineering Intelligent",
  "Digital Solutions for a",
  "Smarter Future.",
];

const lineVariant = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 0.9, delay: 0.15 + i * 0.12, ease: [0.16, 1, 0.3, 1] } }),
};

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-[#07111F] pt-36 pb-24 md:pt-44 md:pb-32 grain" data-testid="hero-section">
      <div className="pointer-events-none absolute -top-40 left-1/4 h-[40rem] w-[40rem] rounded-full opacity-25 blur-3xl accent-bg" />
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.05]"
        style={{ backgroundImage: "linear-gradient(rgba(255,255,255,.7) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.7) 1px,transparent 1px)", backgroundSize: "56px 56px" }}
      />
      <div className="container-x relative grid items-center gap-14 lg:grid-cols-[1.1fr_0.9fr]">
        <div>
          <motion.span
            initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
            className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-xs font-medium text-slate-300"
          >
            <span className="h-1.5 w-1.5 rounded-full accent-bg" /> A technology & innovation company
          </motion.span>

          <h1 className="mt-6 font-display text-5xl font-medium leading-[1.02] tracking-tighter text-white sm:text-6xl lg:text-7xl">
            {LINES.map((line, i) => (
              <span key={i} className="block overflow-hidden py-0.5">
                <motion.span
                  className="block"
                  variants={lineVariant}
                  initial="hidden"
                  animate="show"
                  custom={i}
                >
                  {i === 2 ? <span className="accent-text">{line}</span> : line}
                </motion.span>
              </span>
            ))}
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7, duration: 0.8 }}
            className="mt-7 max-w-xl text-base leading-relaxed text-slate-400 md:text-lg"
          >
            SefKam Digital Solutions helps businesses turn ideas into scalable software,
            AI-powered automation, and intelligent connected experiences.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.85, duration: 0.8 }}
            className="mt-9 flex flex-wrap items-center gap-4"
          >
            <Link to="/services" className="btn-primary" data-testid="hero-primary-cta">
              Explore Our Solutions <ArrowRight size={16} />
            </Link>
            <Link to="/contact" className="btn-ghost border-white/20 text-white hover:bg-white/5" data-testid="hero-secondary-cta">
              Talk to Us <ArrowUpRight size={16} />
            </Link>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1, duration: 0.8 }}
            className="mt-8 font-mono text-xs tracking-wider text-slate-500"
          >
            Software • AI • Automation • Smart Home
          </motion.p>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.92 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.3, duration: 1 }}
          className="flex justify-center lg:justify-end animate-float-slow"
        >
          <EcosystemGraphic />
        </motion.div>
      </div>
    </section>
  );
}
